import { VirtualList } from './VirtualList';
import * as data from './data';
import { Entry } from './data';

type ResultEntryProps = {
  entry: Entry,
  onClick(entry: Entry, evt: Event): void,
  selected: boolean,
};

export function ResultEntry(props: ResultEntryProps) {
  const { entry, onClick, selected } = props;
  function _onClick(evt: Event) {
    onClick(entry, evt);
    evt.preventDefault();
  };
  return (<li class={`indexentry ${selected ? 'result-selected' : ''}`} style={{height: 44,}}>
    <a href={`data/${entry[data.IDX_TARGET]}`} onClick={_onClick}>
      <span class="name">{entry[data.IDX_NAME]}</span>
      <span class="package dimmed">[{entry[data.IDX_PACKAGE]}]</span><br/>
      <span class="namespace dimmed">{entry[data.IDX_NAMESPACE]}</span>
    </a>
  </li>);
}
